export default __webpack_public_path__ + "static/media/sfgif.7e0f3102.gif";